import { motion } from "framer-motion";
import { useLang } from "@/LangContext";

const images = [
  "https://images.unsplash.com/photo-1758273238415-01ec03d9ef27",
  "https://images.pexels.com/photos/10135116/pexels-photo-10135116.jpeg",
  "https://images.pexels.com/photos/36363110/pexels-photo-36363110.jpeg",
  "https://images.pexels.com/photos/19749747/pexels-photo-19749747.jpeg",
];

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" className="py-28 md:py-40 bg-card border-y border-border">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 md:mb-24">
          <h2 className="font-serif text-5xl md:text-7xl tracking-tight leading-[0.9]">{t.services.title}</h2>
          <p className="text-lg text-foreground/60 max-w-xs md:text-right">{t.services.sub}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-x-10 gap-y-20">
          {t.services.list.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`group ${i % 2 === 1 ? "md:mt-24" : ""}`}
              data-testid={`service-${i}`}
            >
              <div className="relative overflow-hidden aspect-[4/5] mb-6">
                <img
                  src={images[i]}
                  alt={s.t}
                  className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 text-xs tracking-widest uppercase bg-background/85 backdrop-blur px-3 py-1.5">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-serif text-3xl md:text-4xl tracking-tight mb-3">{s.t}</h3>
              <p className="text-lg leading-relaxed text-foreground/70 max-w-md">{s.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
